export default {
  user(state: any): any {
    return state.user;
  },
  deviceId(state: any): any | null {
    if (state.deviceId) {
      return state.deviceId;
    }
    return null;
  },
  tenantCode(state: any): any {
    // wasn't there before - deprecated?
    return state.tenantCode;
  },
  staff(state: any): any {
    return state.staff;
  },
  isExpired(state: any): any {
    if (!state.lastLoginDateTime) {
      return true;
    }
    const expireDateTime = new Date(state.lastLoginDateTime);
    expireDateTime.setDate(expireDateTime.getDate() + 7); // １週間
    const now = new Date();

    return now > expireDateTime;
  },
  guest(state: any): any {
    return state.guest;
  },
  tenantId(state: any): number | null {
    if (state.staff && state.staff.myself && state.staff.myself.tenant_id) {
      return state.staff.myself.tenant_id;
    } else if (
      state.guest &&
      state.guest.myself &&
      state.guest.myself.guest &&
      state.guest.myself.guest.tenant &&
      state.guest.myself.guest.tenant.id
    ) {
      return state.guest.myself.guest.tenant.id;
    }
    return null;
  },
  cognitoOtp(state: any): string {
    return state.setCognitoOtp;
  },
  isUserLoggedOut(state: any): string {
    return state.isUserLoggedOut;
  },
  getOneTimeToken(state: any): string {
    return state.oneTimeToken;
  },
  getSubscriptionEndpoint(state: any): string {
    return state.subscriptionEndpoint;
  },
  accessToken(state: any): string {
    return state.accessToken;
  },
  refreshToken(state: any): string {
    return state.refreshToken;
  },
};
